export const PREV_BUTTON_TEXT = `Назад`;
export const NEXT_BUTTON_TEXT = `Вперед`;
